import gql from "graphql-tag";

export default {
  authorDetailsFragment: gql`
    fragment AuthorDetails on Author {
      id
      _id
      name
      bio
      imageUrl
      websiteUrl
      twitterHandle
      instagramHandle
      tiktokHandle
      facebookHandle
      youtubeHandle
      createdAt
      updatedAt
    }
  `,
};
